angular.module('rjmNg.directives').directive "windowListener", [
  "$window"
  ($window) ->
    restrict: "A"
    scope:
      onResize: "&"
    link: (scope, elem) ->
      # Simple directive to pass in a callback for window events
      # Example usage <table window-listener on-resize="refresh()">
      $($window).on 'resize', (event) ->
        scope.onResize()
]
